import { useState, useEffect } from "react";
import clsx from "clsx";

import { Filter } from "@transfr-inc/dashboard-components/forms";
import container from "@src/container";
import { useApiRequest } from "@lib/hooks";

export function ProgramFilter({
  orgCode,
  onProgramSelected,
  placeholder = "Filter by Program",
  className,
  professionalLearning,
}) {
  const defaultOption = { displayName: "All Programs" };
  const { courseService } = container;
  const [programs, setPrograms] = useState([defaultOption]);

  const { sendRequest: getPrograms } = useApiRequest(
    () =>
      courseService.getOrganizationPrograms(orgCode).then((response) => {
        const filtered = response.filter(
          (program) => program.professionalLearning === professionalLearning
        );
        const mappedResponse = filtered.map((program) => ({
          displayName: program.title,
          value: program.id,
          programId: program.id,
        }));
        setPrograms([defaultOption, ...mappedResponse]);
      }),
    false
  );

  useEffect(() => {
    getPrograms();
  }, [orgCode]);

  return (
    <Filter
      className={clsx("classroom-filter small", className)}
      placeholder={placeholder}
      data={programs}
      clearValue={programs[0]}
      onFilterSelected={onProgramSelected}
      labelKey={"displayName"}
    ></Filter>
  );
}
